"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanSource = void 0;
const core_1 = require("flow-connect/core");
class BooleanSource extends core_1.Node {
    constructor() {
        super();
    }
    setupIO() {
        this.addTerminals([{ type: core_1.TerminalType.OUT, name: "value", dataType: "boolean" }]);
    }
    created(options) {
        const { width = 130, name = "Boolean Source", state = {}, style = {} } = options;
        this.width = width;
        this.name = name;
        this.state = Object.assign(Object.assign({}, BooleanSource.DefaultState), state);
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.setupUI();
        this.setupListeners();
    }
    process() {
        this.setOutputs(0, this.state.value);
    }
    setupUI() {
        this.toggleInput = this.createUI("core/toggle", {
            propName: "value",
            input: true,
            output: true,
            height: 10,
            style: { grow: 0.4 },
        });
        this.ui.append(this.createUI("core/x-layout", {
            childs: [this.createUI("core/label", { text: "Value" }), this.toggleInput],
            style: { spacing: 20 },
        }));
    }
    setupListeners() {
        this.watch("value", () => this.process());
    }
}
exports.BooleanSource = BooleanSource;
BooleanSource.DefaultState = { value: false };
